import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import api from '../../utils/api';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/reset-password', { token, password: data.password });
            navigate('/login?reset=ok');
        } catch (err) {
            setError(err.response?.data?.error || 'Error actualizando contraseña');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="text-red-500">Token inválido o expirado.</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-fondo)' }}>
            <div className="bg-white rounded-2xl shadow-lg p-10 w-full max-w-md">
                <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">Nueva contraseña</h1>
                <p className="text-gray-500 text-sm text-center mb-8">Ingresa tu nueva contraseña</p>

                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nueva contraseña</label>
                        <input
                            type="password"
                            {...register('password', {
                                required: 'La contraseña es requerida',
                                minLength: { value: 8, message: 'Mínimo 8 caracteres' },
                                pattern: {
                                    value: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])/,
                                    message: 'Debe tener mayúscula, número y carácter especial'
                                }
                            })}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none"
                            placeholder="••••••••"
                        />
                        {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar contraseña</label>
                        <input
                            type="password"
                            {...register('confirm', {
                                required: 'Confirma la contraseña',
                                validate: val => val === watch('password') || 'Las contraseñas no coinciden'
                            })}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none"
                            placeholder="••••••••"
                        />
                        {errors.confirm && <p className="text-red-500 text-xs mt-1">{errors.confirm.message}</p>}
                    </div>

                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg px-4 py-3">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full text-white font-semibold py-2.5 rounded-lg transition-opacity disabled:opacity-60"
                        style={{ backgroundColor: 'var(--color-primary)' }}
                    >
                        {loading ? 'Actualizando...' : 'Actualizar contraseña'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
